import { render, staticRenderFns } from "./mortgage-details.vue?vue&type=template&id=6977ffd2"
import script from "./mortgage-details.vue?vue&type=script&lang=js"
export * from "./mortgage-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports